PageApp.Ent.ExchangeRate = Backbone.Model.extend({
  initialize: function () {
  }
})
